import styled from 'styled-components';
export const TabItem = styled.button`
  width: 50%;
  background-color: #fafafa;
  box-shadow: rgb(0 0 0 / 15%) 0px 0.5rem 0.5rem;
  transition: all 0.3s ease-in-out 0s;
  display: block;
  text-align: center;
  font-weight: bolder;
  text-transform: uppercase;
  cursor: pointer;
  letter-spacing: 0.15rem;
  padding: 1.2rem 0;
  font-size: 1.2rem;
  transition: all 0.5s ease-in-out 0s;
  color: ${(props) => (props.active ? '#4e6e29' : '#000')};
  border: 0;
  outline: 0;
  &:hover {
    transform: scale(0.9);
    color: #4e6e29;
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 80%;
  margin-top: 4rem;
  margin-bottom: 2rem;
`;
